import { SessionsAPI } from "../infrastructure/api/sessions.api";
import { isAiConsentRequired, putToSignedUrl } from "../infrastructure/recordingUpload";

export { isAiConsentRequired };

/**
 * Hand a session's recording to the backend for transcription and analysis.
 *
 * 1. Ask the API for a short-lived signed URL — no file bytes go through the API.
 * 2. Upload directly to storage (any size, no API timeout).
 * 3. Trigger background processing (lightweight — it only publishes a message).
 *
 * `durationSeconds` is the recorder's clock when there was one: the session's
 * real length, which replaces the planned one. An uploaded file has none.
 */
export async function uploadSessionAudio(
    sessionId: string,
    audio: Blob,
    contentType: string,
    durationSeconds?: number
): Promise<void> {
    const {
        data: { upload_url, storage_path },
    } = await SessionsAPI.get_upload_url(sessionId, contentType);

    await putToSignedUrl(upload_url, audio, contentType);

    await SessionsAPI.trigger_processing(
        sessionId,
        durationSeconds === undefined
            ? { storage_path, content_type: contentType }
            : { storage_path, content_type: contentType, duration_seconds: durationSeconds }
    );
}
